import i18n, { ParseKeys } from 'i18next'
// import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import he from './locales/he.json'
export type TransKey = ParseKeys
export const defaultNS = 'translation' as const
export const resources = {
  en: { translation: en },
  he: { translation: he },
} as const

const STORAGE_KEY = 'i18nextLng'

function getStoredLanguage(): 'he' | 'en' {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'en' || stored === 'he') return stored
  } catch {
    // ignore
  }
  return 'he'
}

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    lng: getStoredLanguage(),
    fallbackLng: 'he',
    supportedLngs: ['he', 'en'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b'],
    },
  })

i18n.on('languageChanged', lng => {
  try {
    localStorage.setItem(STORAGE_KEY, lng)
  } catch {
    // ignore
  }
})
export default i18n
